import { alpha, Button, ButtonProps, darken } from "@mui/material";
import { LinkButton, LinkButtonProps } from "features/navigation/LinkButton";
import _ from "lodash";
import { IconWithinButton } from "./IconWithinButton";
import lotusIcon from "images/icons/lotus.svg";
import lotusDark from "images/icons/lotus-dark-bold.svg";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({}));

interface AdditionalProps {
    iconHeight?: number;
}

export type ButtonWithLotusProps = ButtonProps & AdditionalProps;

const getIcon = (variant?: string) => {
    if (
        variant === "primary" ||
        variant === "destructive" ||
        variant === "secondaryInverse" ||
        variant === "destructiveInverse"
    ) {
        return lotusIcon;
    } else {
        return lotusDark;
    }
};

export const ButtonWithLotus = (props: ButtonWithLotusProps) => {
    const iconHeight = props.iconHeight ?? (props.size === "large" ? 50 : 35);
    const icon = getIcon(props.variant);
    const classes = useStyles();

    return (
        <Button
            variant={props.variant}
            size="small"
            {..._.omit(props, "icon", "iconHeight")}
            className={props.className}
        >
            <IconWithinButton iconHeight={iconHeight} icon={icon} />
            {props.children}
        </Button>
    );
};
